import { useEffect, useState } from 'react';
import { criarFavorito, deletarTelaFavoritada } from '../../../api/autenticacao';
import { buscarTelaAtual, getMenusDepartamento } from '../../../services/authentication/auth';
import { useMenuSidebar } from '../../../contexts/MenuSidebarContext';
import { useNavegacao } from '../../../hooks/useNavegacao';
import { ProjetosEnum } from '../../Shared/Enums/ProjetosEnum';
import { DepartamentosEnum } from '../../Shared/Enums/DepartamentosEnum';

const useConfiguracoesHook = ({ setEscopoAcesso }) => {
  const codMenuDepartamento = 10;
  const [filtro, setFiltro] = useState('');
  const [expanded, setExpanded] = useState(false);
  const [isPendingMenu, setIsPendingMenu] = useState(false);
  const [disableTooltip, setDisableTooltip] = useState(false);
  const [lstMenusConfiguracao, setLstMenusConfiguracao] = useState([]);
  const [menusFiltrados, setMenusFiltrados] = useState([]);
  const [loadingFavoritoId, setLoadingFavoritoId] = useState([]);
  const { scrIframeConfiguracoes } = useMenuSidebar();
  const { navegarTela, getSetMenusPrincipais } = useNavegacao({ setEscopoAcesso });

  const handleFavorito = async (menuId, subMenuId, favorito) => {
    if (loadingFavoritoId === subMenuId) return;

    setLoadingFavoritoId(`${menuId}_${subMenuId}`);

    try {
      if (favorito) {
        await deletarTelaFavoritada(subMenuId);
      } else {
        await criarFavorito(subMenuId);
      }
      buscaLstMenusConfiguracao(false);
      setMenusFiltrados(prev =>
        prev.map(menu =>
          menu.id === menuId
            ? {
                ...menu,
                subMenus: menu.subMenus.map(sub =>
                  sub.id === subMenuId ? { ...sub, favorito: !sub.favorito } : sub
                )
              }
            : menu
        )
      );
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingFavoritoId(null);
    }
  };

  const handleSearch = () => {
    const textoFiltro = String(filtro ?? '').trim();

    if (!textoFiltro) {
      setMenusFiltrados(lstMenusConfiguracao);
      return;
    }

    if (/^\d+$/.test(textoFiltro)) {
      const id = parseInt(textoFiltro, 10);
      const filtradoPorId = lstMenusConfiguracao
        .map(menu => {
          if (menu.id === id) return menu;

          const subMenusFiltrados = (menu.subMenus || []).filter(sm => sm.id === id);

          if (subMenusFiltrados.length > 0) {
            return { ...menu, subMenus: subMenusFiltrados };
          }
          return null;
        })
        .filter(Boolean);

      setMenusFiltrados(filtradoPorId);
      return;
    }

    const filtroNormalizado = normalizarTexto(textoFiltro);
    const filtradoPorTexto = lstMenusConfiguracao
      .map(menu => {
        const subMenusFiltrados = (menu.subMenus || []).filter(subMenu =>
          normalizarTexto(subMenu.texto).includes(filtroNormalizado)
        );

        if (subMenusFiltrados.length > 0) {
          return { ...menu, subMenus: subMenusFiltrados };
        }
        return null;
      })
      .filter(Boolean);

    setMenusFiltrados(filtradoPorTexto);
  };

  const normalizarTexto = texto =>
    texto
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9 ]/g, '')
      .toLowerCase();

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleKeyUp = () => {
    const filtroLower = filtro.toLowerCase();
    if (!filtroLower.trim()) {
      setMenusFiltrados(lstMenusConfiguracao);
    } else {
      handleSearch();
    }
  };

  const buscaLstMenusConfiguracao = (loading = true) => {
    getSetMenusPrincipais({
      codDepartamento: codMenuDepartamento,
      fnSetData: setLstMenusConfiguracao,
      fnLoading: setIsPendingMenu,
      loading
    });
  };

  const verificaConfiguracoesSessionStorage = () => {
    const lstMenuConfiguracao = getMenusDepartamento(codMenuDepartamento);
    if (lstMenuConfiguracao) {
      setLstMenusConfiguracao(lstMenuConfiguracao);

      const { menuAtual, projetoAtual, rotaAtual } = buscarTelaAtual('-conf');
      if (projetoAtual !== ProjetosEnum.PLATAFORMA_CRM && menuAtual && rotaAtual && projetoAtual) {
        navegarTela(menuAtual, rotaAtual, projetoAtual, DepartamentosEnum.CONFIGURACOES);
      }
    } else {
      buscaLstMenusConfiguracao();
    }
  };

  const handleChangeAccordion = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  useEffect(() => {
    verificaConfiguracoesSessionStorage();
    setDisableTooltip(false);
  }, []);

  useEffect(() => {
    if (lstMenusConfiguracao.length > 0) {
      setMenusFiltrados(lstMenusConfiguracao);
    }
  }, [lstMenusConfiguracao]);

  return {
    filtro,
    setFiltro,
    expanded,
    setExpanded,
    isPendingMenu,
    setIsPendingMenu,
    disableTooltip,
    setDisableTooltip,
    lstMenusConfiguracao,
    setLstMenusConfiguracao,
    handleSearch,
    handleKeyDown,
    handleKeyUp,
    buscaLstMenusConfiguracao,
    verificaConfiguracoesSessionStorage,
    handleChangeAccordion,
    menusFiltrados,
    scrIframeConfiguracoes,
    navegarTela,
    handleFavorito,
    loadingFavoritoId
  };
};

export default useConfiguracoesHook;
